import React, { useEffect, useRef } from "react";
import s from "./style.module.css";

const VideoEmbed = ({ id }) => {
  return (
    <div className={s.container}>
      <iframe
        className={s.inner}
        src={`https://www.youtube.com/embed/${id}?modestbranding=1&rel=0`}
        width="560"
        height="315"
        frameborder="0"
      ></iframe>
    </div>
  );
};

export default VideoEmbed;
